import { BLOCKS } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, next) => `<p class="cms">${next(node.content).replace(/\n/g, '<br/>')}</p>`,
  },
};

export default function renderHtml(document) {
  return documentToHtmlString(document, options);
}
